import { jsx as _jsx } from "react/jsx-runtime";
import { ArchiveIcon, CubeIcon, FileIcon, ImageIcon, LayersIcon, MagicWandIcon, } from '@radix-ui/react-icons';
import { useUIStore } from '../../stores';
import { SidebarColumn } from './SidebarColumn';
import { SceneList } from './ToolPads/SceneList';
import { Library } from './ToolPads/Library';
import { SceneObjectList } from './ToolPads/SceneObjectList';
import { SceneEffectList } from './ToolPads/SceneEffectList';
import { ClipFolders } from './ToolPads/ClipFolders';
import { MoviePropertiesToolpad } from './ToolPads/MovieProperties';
const LEFT_TOOLPAD_ORDER = {
    movieProperties: 0,
    sceneList: 1,
    library: 2,
    sceneObjectList: 3,
    sceneEffectList: 4,
    clipFolders: 5,
};
const LEFT_RAIL_META = {
    movieProperties: { icon: _jsx(FileIcon, { width: 16, height: 16 }), titleKey: 'toolpads.movieProperties.title' },
    sceneList: { icon: _jsx(LayersIcon, { width: 16, height: 16 }), titleKey: 'toolpads.scenes.title' },
    library: { icon: _jsx(ImageIcon, { width: 16, height: 16 }), titleKey: 'toolpads.library.title' },
    sceneObjectList: { icon: _jsx(CubeIcon, { width: 16, height: 16 }), titleKey: 'toolpads.sceneObjects.title' },
    sceneEffectList: { icon: _jsx(MagicWandIcon, { width: 16, height: 16 }), titleKey: 'toolpads.sceneEffects.title' },
    clipFolders: { icon: _jsx(ArchiveIcon, { width: 16, height: 16 }), titleKey: 'toolpads.clipFolders.title' },
};
export function LeftSidebar() {
    const { toolpads, leftSidebarOpen, setLeftSidebar, openToolpad, } = useUIStore();
    const leftToolpads = Object.values(toolpads)
        .filter((tp) => tp.position === 'left')
        .sort((a, b) => {
        const aRank = LEFT_TOOLPAD_ORDER[a.id] ?? 100;
        const bRank = LEFT_TOOLPAD_ORDER[b.id] ?? 100;
        return aRank - bRank;
    });
    const railItems = leftToolpads.flatMap((tp) => {
        const meta = LEFT_RAIL_META[tp.id];
        if (!meta)
            return [];
        return [{ id: tp.id, icon: meta.icon, titleKey: meta.titleKey }];
    });
    const handleExpandToolpad = (id) => {
        openToolpad(id);
        setLeftSidebar(true);
    };
    return (_jsx(SidebarColumn, { side: "left", isOpen: leftSidebarOpen, onCollapse: () => setLeftSidebar(false), onExpandToolpad: handleExpandToolpad, items: railItems, children: leftToolpads.map((tp) => (_jsx(ToolpadWrapper, { toolpadId: tp.id }, tp.id))) }));
}
function ToolpadWrapper({ toolpadId }) {
    switch (toolpadId) {
        case 'library':
            return _jsx(Library, {});
        case 'sceneList':
            return _jsx(SceneList, {});
        case 'sceneObjectList':
            return _jsx(SceneObjectList, {});
        case 'sceneEffectList':
            return _jsx(SceneEffectList, {});
        case 'clipFolders':
            return _jsx(ClipFolders, {});
        case 'movieProperties':
            return _jsx(MoviePropertiesToolpad, {});
        default:
            return null;
    }
}
